import React, { useEffect, useState } from 'react';
import adminService from '../../services/adminService';

const AdminDataEditor = ({ filename }) => {
  const [rows, setRows] = useState([]);
  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [newRole, setNewRole] = useState('a');

  const refresh = async () => {
    try {
      const list = await adminService.getActiveAdmins();
      setRows(Array.isArray(list) ? list : []);
    } catch (_) {
      setRows([]);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const handleUpdate = (id, username, password, role) => {
    (async () => {
      try {
        await adminService.updateCredentialsById(id, { username, password, role });
        // Reload the whole page to ensure all dependent views pick up changes
        if (typeof window !== 'undefined' && window.location) {
          window.location.reload();
          return;
        }
        await refresh();
        setMessage('已更新。');
      } catch (e) {
        setMessage('更新失敗');
      } finally {
        setTimeout(() => setMessage(''), 1500);
      }
    })();
  };

  const handleDelete = (id) => {
    (async () => {
      try {
        await adminService.softDeleteById(id);
        if (typeof window !== 'undefined' && window.location) {
          window.location.reload();
          return;
        }
        await refresh();
        setMessage('已刪除。');
      } catch (e) {
        setMessage('刪除失敗');
      } finally {
        setTimeout(() => setMessage(''), 1500);
      }
    })();
  };

  const handleCreate = () => {
    const u = String(newUsername || '').trim();
    const p = String(newPassword || '').trim();
    if (!u || !p) {
      setMessage('用戶名和密碼為必填項。');
      setTimeout(() => setMessage(''), 1800);
      return;
    }
    (async () => {
      try {
        await adminService.createAdmin(u, p, newRole === 's' ? 's' : 'a');
        setNewUsername('');
        setNewPassword('');
        setNewRole('a');
        if (typeof window !== 'undefined' && window.location) {
          window.location.reload();
          return;
        }
        await refresh();
        setMessage('已創建。');
      } catch (e) {
        setMessage('創建失敗');
      } finally {
        setTimeout(() => setMessage(''), 1500);
      }
    })();
  };

  const onChangeCell = (id, field, value) => {
    setRows((prev) => prev.map((r) => (r.id === id ? { ...r, [field]: value } : r)));
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-sm align-middle">
            <thead>
              <tr>
                <th style={{ width: 80 }}>ID</th>
                <th>用戶名</th>
                <th>密碼</th>
                <th style={{ width: 140 }}>角色</th>
                <th style={{ width: 200 }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={row.username || ''}
                      onChange={(e) => onChangeCell(row.id, 'username', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={row.password || ''}
                      onChange={(e) => onChangeCell(row.id, 'password', e.target.value)}
                    />
                  </td>
                  <td>
                    <select
                      className="form-select form-select-sm"
                      value={row.role || 'a'}
                      onChange={(e) => onChangeCell(row.id, 'role', e.target.value === 's' ? 's' : 'a')}
                    >
                      <option value="s">超級管理員 (s)</option>
                      <option value="a">管理員 (a)</option>
                    </select>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => handleUpdate(row.id, row.username, row.password, row.role || 'a')}
                      >
                        更新
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(row.id)}
                      >
                        刪除
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              <tr>
                <td className="text-muted">auto</td>
                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="新用戶名"
                    value={newUsername}
                    onChange={(e) => setNewUsername(e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="新密碼"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </td>
                <td>
                  <select
                    className="form-select form-select-sm"
                    value={newRole}
                    onChange={(e) => setNewRole(e.target.value === 's' ? 's' : 'a')}
                  >
                    <option value="s">超級管理員 (s)</option>
                    <option value="a">管理員 (a)</option>
                  </select>
                </td>
                <td>
                  <button type="button" className="btn btn-sm btn-success" onClick={handleCreate}>創建</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {message && <div className="text-success small">{message}</div>}
      </div>
    </div>
  );
};

export default AdminDataEditor;
